import { Wrench, Zap } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import type { ToolkitAction } from '@/frontend/pages/Dashboard/Composio/types'

interface ComposioToolkitDetailsProps {
  tools: ToolkitAction[]
  triggers: ToolkitAction[]
}

function ActionList({ items }: { items: ToolkitAction[] }) {
  if (items.length === 0) {
    return <p className="text-sm text-muted-foreground py-6 text-center">Nenhum item disponível.</p>
  }

  return (
    <div className="divide-y divide-border">
      {items.map((item) => (
        <div key={item.name} className="py-3">
          <p className="text-sm font-medium text-foreground">{item.name}</p>
          {item.description && (
            <p className="text-xs text-muted-foreground mt-0.5">{item.description}</p>
          )}
        </div>
      ))}
    </div>
  )
}

export default function ComposioToolkitDetails({ tools, triggers }: ComposioToolkitDetailsProps) {
  return (
    <Card>
      <CardContent className="p-6">
        <Tabs defaultValue="tools">
          <TabsList>
            <TabsTrigger value="tools">
              <Wrench />
              Ferramentas ({tools.length})
            </TabsTrigger>
            <TabsTrigger value="triggers">
              <Zap />
              Gatilhos ({triggers.length})
            </TabsTrigger>
          </TabsList>
          <TabsContent value="tools" className="max-h-96 overflow-y-auto">
            <ActionList items={tools} />
          </TabsContent>
          <TabsContent value="triggers" className="max-h-96 overflow-y-auto">
            <ActionList items={triggers} />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  )
}
